import React from 'react';
import { Heading } from './Heading';
import { Reveal } from './Reveal';
type SectionHeaderProps = {
  eyebrow: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  align?: 'left' | 'center';
  tone?: 'default' | 'inverse';
};
export function SectionHeader({
  eyebrow,
  title,
  subtitle,
  align = 'left',
  tone = 'default'
}: SectionHeaderProps) {
  const centered = align === 'center';
  return <Reveal className={centered ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-344" data-mp="1ar5m3nevun4d">
      <div className={`flex items-center gap-3 ${centered ? 'justify-center' : ''}`} data-id="element-345" data-mp="15su8d1lgvsgv">
        <span aria-hidden className="flex h-1.5 overflow-hidden rounded-full" data-id="element-346" data-mp="1khgze0kgi8nx">
          <span className="w-6 bg-accent-gold" data-id="element-347" data-mp="1kjjmocu85noy" />
          <span className="w-3 bg-primary" data-id="element-348" data-mp="1fi40uik83d5i" />
          <span className="w-3 bg-secondary-maroon" data-id="element-349" data-mp="1fj5mti2s1k20" />
        </span>
        <span className={`text-xs font-bold uppercase tracking-[0.2em] ${tone === 'inverse' ? 'text-white/80' : 'text-primary'}`} data-id="element-350" data-mp="1tj6p91yowzjl">
          {eyebrow}
        </span>
      </div>
      <Heading level={2} size="lg" align={centered ? 'center' : 'left'} className={`type-h2 mt-4 ${tone === 'inverse' ? '!text-white' : ''}`} data-id="element-351" data-mp="3dwuy0qrbeivj">
        {title}
      </Heading>
      {subtitle && <p className={`mt-4 text-base leading-relaxed md:text-lg ${tone === 'inverse' ? 'text-white/75' : 'text-foreground/70'}`} data-id="element-352" data-mp="3rv1ohltxpgl6">
          {subtitle}
        </p>}
    </Reveal>;
}